<div class="buy-deso__container p-16px fc-default border">
  <div class="d-flex flex-column align-items-center">
    <div class="fs-24px font-weight-bold pt-2 text-center">Upgrade Alert: Enhanced Security & Speed!</div>
    <div class="px-5 text-center">
      <div class="fs-18px pt-1 mb-3">
        We've upgraded Diamond for better security and faster performance! Key improvements include:
      </div>
      <ul class="text-left">
        <li class="fs-16px pt-1">
          <strong>Advanced Security:</strong>
          Derived keys for transaction signing - your main wallet stays secure.
        </li>
        <li class="fs-16px pt-1">
          <strong>Faster Loading:</strong>
          A lighter weight JavaScript library for a seamless browsing experience.
        </li>
      </ul>
      <div class="fs-18px pt-1">
        These changes require you to log back in to enjoy the upgraded Diamond experience. Apologies for any
        inconvenience, and thank you for your support!
      </div>
    </div>
    <div class="d-flex w-100 align-items-center justify-content-center pt-4">
      <button
        class="btn btn-outline-secondary mb-4 br-12px p-3 font-weight-bold background-color-white fc-default"
        (click)="login()"
      >
        <img src="/assets/deso/desologo.svg" alt="DeSo identity" height="24" />
        &nbsp;Log in with DeSo
      </button>
    </div>
  </div>
</div>
